import { DataGridPro, DataGridLocaleEnNL, DataGridLocaleNlNL, type DataGridProProps } from '@dhl/components'
import { useLocale } from '@dhl/i18n'

export const AdminDataGrid = <T extends object = any>(props: DataGridProProps) => {
  const { columns, ...restProps } = props
  const locale = useLocale()
  const localeText = locale.split('-')[0] === 'en' ? DataGridLocaleEnNL : DataGridLocaleNlNL

  // Disable sorting unless specified on a column
  const newColumns = columns.map((column) => {
    return {
      ...column,
      sortable: column.sortable === undefined ? false : column.sortable,
    }
  })

  return (
    <DataGridPro disableColumnSelector disableColumnMenu {...restProps} columns={newColumns} localeText={localeText} />
  )
}
